import { Component, OnInit, Input } from '@angular/core';

import { GetUserMagazineService } from "../../../services/magazine/getUserSubMagazine/get-user-magazine.service";
import { UpdateMagazineService } from "../../../services/magazine/updateMagazine/update-magazine.service";
import { DeleteMagazineService } from "../../../services/magazine/deleteMagazine/delete-magazine.service";
import { LoginService } from "../../../services/auth/login/login.service";
import { AddMagazineService } from "../../../services/magazine/addMagazine/add-magazine.service";

import Swal from 'sweetalert2'
import { async } from '@angular/core/testing';

declare var $: any

@Component({
  selector: 'app-magazine-details',
  templateUrl: './magazine-details.component.html',
  styleUrls: ['./magazine-details.component.less']
})
export class MagazineDetailsComponent implements OnInit {

  @Input('getMagazineDetailsByID') ID: any;

  public UserID: any
  public title: any
  public name: any
  public magazine: any = []
  public expire_date: any
  public mainLoader: Boolean = true
  public showEdit: Boolean = false
  public showAdd: Boolean = false
  public selectedLanguage: any
  public selectedLanguageEdit: any
  public selectIDEdit: any

  /** Button loader */
  public submitLoading: Boolean = false
  public submitLoading1: Boolean = false


  /**
    * skeletonLoader
    */
  public languageSkeleton = true
  public periodSkeleton = true

  constructor(
    private GetUserMagazineService: GetUserMagazineService,
    private UpdateMagazineService: UpdateMagazineService,
    private LoginService: LoginService,
    private DeleteMagazineService: DeleteMagazineService,
    private AddMagazineService: AddMagazineService
  ) { }

  ngOnInit() {
  }

  async magazineDetails(id, title, name) {
    this.UserID = id
    this.title = title
    this.name = name
    $("#magazineDetails").modal("show");
    let result = await this.GetUserMagazineService.getAllSubMagazine(id)
    if (result.status == "success") {
      this.mainLoader = false
      this.magazine = result.data
    }
  }


  async edit(id, language, expire_date) {
    this.showEdit = true
    this.selectIDEdit = id
    this.selectedLanguage = language
    this.selectedLanguageEdit = language
    this.expire_date = expire_date
    switch (id) {
      case 0:
        $('#id1').hide();
        $('#id2').hide();
        break;
      case 1:
        $('#id0').hide();
        $('#id2').hide();
        break;
      case 2:
        $('#id0').hide();
        $('#id1').hide();
        break;
      default:
        break;
    }
  }

  async cancelEdit() {
    this.showEdit = false
    this.showAdd = false
    this.languageSkeleton = true
    this.periodSkeleton = true
    this.periodRequired = false
    $('#id0').show();
    $('#id1').show();
    $('#id2').show();
  }

  periodRequired: Boolean = false
  languageRequired: Boolean = false
  async editMagazine(val) {
    console.log(val.language)
    this.submitLoading = true
    let pattern = /\b[0-9]{4,4}-[0-9]{2,2}\b/;
    let user_id = JSON.parse(localStorage.getItem("userDetails"))

    if (user_id == undefined || user_id == null) await this.LoginService.userLogOut()

    if (!pattern.test(val.period)) {
      this.periodRequired = true
      this.submitLoading = false
    } else {
      this.periodRequired = false
    }
    if (this.periodRequired == false) {
      let data = {
        "partner_id": parseInt(this.UserID),
        "language_id": val.language == "Tamil" ? 19 : val.language == "English" ? 1 : val.language == "Hindi" ? 7 : 0,
        "magazine_id": this.selectedLanguageEdit == "Tamil" ? 19 : this.selectedLanguageEdit == "English" ? 1 : this.selectedLanguageEdit == "Hindi" ? 7 : 0,
        "expire_date": val.period,
        "is_active": 1,
        "user_id": parseInt(user_id.STAFF_ID)
      }
      let result = await this.UpdateMagazineService.updateMagazine(data)
      console.log(result)
      if (result.status == "success") {
        this.submitLoading = false
        this.magazine[this.selectIDEdit] = {
          is_active: 1,
          language_name: val.language,
          expire_date: val.period
        }
        this.cancelEdit()
        Swal.fire(
          'Updated!',
          'Your changes updated successfully.',
          'success'
        )
      } else {
        this.cancelEdit()
        this.submitLoading = false
        Swal.fire(
          'Failed!',
          'Failed to update...',
          'error'
        )
      }
    }
  }

  async addMagazineForm() {
    $('#id0').hide();
    $('#id1').hide();
    $('#id2').hide();
    this.showAdd = true
  }

  periodRequired1: Boolean = false
  async addMagazine(val) {
    this.submitLoading1 = true
    console.log(val)
    let pattern = /\b[0-9]{4,4}-[0-9]{2,2}\b/;
    let user_id = JSON.parse(localStorage.getItem("userDetails"))

    if (user_id == undefined || user_id == null) await this.LoginService.userLogOut()

    if (!pattern.test(val.period)) {
      this.periodRequired1 = true
      this.submitLoading1 = false
    } else {
      this.periodRequired1 = false
    }
    if (this.periodRequired1 == false) {
      let data = {
        "partner_id": parseInt(this.UserID),
        "language_id": val.language == "Tamil" ? 19 : val.language == "English" ? 1 : val.language == "Hindi" ? 7 : 0,
        "expire_date": val.period,
        "is_active": 1,
        "user_id": parseInt(user_id.STAFF_ID)
      }
      let result = await this.AddMagazineService.addNewMagazine(data)
      if (result.status == "success") {
        this.submitLoading1 = false
        this.magazine.push({
          is_active: 1,
          language_name: val.language,
          expire_date: val.period
        })
        this.cancelEdit()
        Swal.fire(
          'Added!',
          'Your Magazine added successfully.',
          'success'
        )
      } else {
        this.cancelEdit()
        this.submitLoading1 = false
        Swal.fire(
          'Failed!',
          'Failed to Add...',
          'error'
        )
      }
    }

  }


  async delete(index, language_id) {
    let user_id = JSON.parse(localStorage.getItem("userDetails"))
    if (user_id == undefined || user_id == null) await this.LoginService.userLogOut()
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to deactivate this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, deactivate it!'
    }).then(async (result) => {
      if (result.value) {
        let data = {
          "partner_id": parseInt(this.UserID),
          "language_id": parseInt(language_id),
          "user_id": parseInt(user_id.STAFF_ID)
        }
        let res = await this.DeleteMagazineService.deleteMagazine(data)
        console.log(res)
        if (res.status == "success") {
          Swal.fire(
            'Deactivated!',
            'Your magazine has been Deactivated.',
            'success'
          )
          // let array = this.magazine[]
          // console.log(array)
          // array.splice(index, 1);
          // this.magazine = array
          // console.log(this.magazine)
          this.magazine[index].is_active = 0
        } else {
          Swal.fire(
            'Failed!',
            'Failed to Deactivated.',
            'error'
          )
        }
      }
    })
  }

  async validateFormat(val) {
    let pattern = /\b[0-9]{4,4}-[0-9]{2,2}\b/;
    if (!pattern.test(val.period)) {
      this.periodRequired = true
      this.periodRequired1 = true
    } else {
      this.periodRequired = false
      this.periodRequired1 = false
    }
  }

}
